function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_61",
  "data-name": "Group 61",
  transform: "translate(-0.886 -34.327)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_611",
  "data-name": "Path 611",
  d: "M48.207,28.661c0-3.375-2.661-5.49-6.7-5.49H35.921V38.618h3.565V34.269h1.751l2.954,4.349h3.9v-.095l-3.5-4.8a5.32,5.32,0,0,0,3.62-5.066m-8.722-2.519h1.783c2.352,0,3.279,1.045,3.279,2.519,0,1.616-.927,2.638-3.279,2.638H39.486Z",
  transform: "translate(-16.142 11.394)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_612",
  "data-name": "Path 612",
  d: "M8.648,22.726a7.955,7.955,0,0,0-8.08,7.961,7.667,7.667,0,0,0,8.08,7.962,7.667,7.667,0,0,0,8.08-7.962,7.955,7.955,0,0,0-8.08-7.961m0,12.952c-2.472,0-4.515-2.02-4.515-4.991S6.177,25.7,8.648,25.7c2.5,0,4.515,1.9,4.515,4.99S11.144,35.678,8.648,35.678Z",
  transform: "translate(0.318 11.601)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_613",
  "data-name": "Path 613",
  d: "M62.558,23.171V26.26H65.98V38.618h3.565V26.26h3.47V23.171Z",
  transform: "translate(-28.544 11.394)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_614",
  "data-name": "Path 614",
  d: "M97.1,29.4H91.159V23.171H87.594V38.618h3.565v-6.25H97.1v6.25h3.565V23.171H97.1Z",
  transform: "translate(-40.2 11.394)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_615",
  "data-name": "Path 615",
  d: "M225.693,23.149h-4.824V38.6h5.061c5.253,0,8.889-3.113,8.889-7.652,0-4.777-3.613-7.795-9.127-7.795m.025,12.476h-1.284V26.12h1.284c3.8,0,5.442,2,5.442,4.824C231.159,33.819,229.52,35.625,225.717,35.625Z",
  transform: "translate(-102.251 11.404)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_139",
  "data-name": "Rectangle 139",
  width: 3.565,
  height: 15.447,
  transform: "translate(111.512 34.553)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_616",
  "data-name": "Path 616",
  d: "M255.651,35.625V32.179h5.822V29.447h-5.822V26.119h7.106V23.149H252.086V38.6h10.979v-2.97Z",
  transform: "translate(-116.786 11.404)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_617",
  "data-name": "Path 617",
  d: "M192.065,28.639c0-3.375-2.661-5.49-6.7-5.49h-5.585V38.6h3.565V34.247H185.1l2.954,4.349h3.9v-.1l-3.5-4.8a5.318,5.318,0,0,0,3.62-5.066m-8.721-2.519h1.782c2.352,0,3.28,1.045,3.28,2.519,0,1.616-.927,2.637-3.28,2.637h-1.782Z",
  transform: "translate(-83.12 11.404)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_618",
  "data-name": "Path 618",
  d: "M125.246,22.726a7.956,7.956,0,0,0-8.08,7.961,8.081,8.081,0,0,0,16.16,0,7.955,7.955,0,0,0-8.08-7.961m0,12.952c-2.472,0-4.515-2.02-4.515-4.991s2.044-4.99,4.515-4.99c2.5,0,4.515,1.9,4.515,4.99S127.742,35.678,125.246,35.678Z",
  transform: "translate(-53.969 11.601)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_619",
  "data-name": "Path 619",
  d: "M158.1,23.149h-5.585V38.6h3.565V34.247h2.02c3.946,0,6.7-2.281,6.7-5.609,0-3.374-2.662-5.489-6.7-5.489m-.237,8.128h-1.782V26.12h1.782c2.353,0,3.28,1.045,3.28,2.519C161.146,30.255,160.219,31.277,157.866,31.277Z",
  transform: "translate(-70.428 11.404)",
  fill: "#fff"
}));

function SvgCompanyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.394,
    height: 15.923,
    viewBox: "0 0 145.394 15.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo);
export default __webpack_public_path__ + "static/media/company-logo.c31569e1.svg";
export { ForwardRef as ReactComponent };